import { render } from "./PatrimoineList.vue?vue&type=template&id=53de8bcf&scoped=true"
import script from "./PatrimoineList.vue?vue&type=script&lang=js"
export * from "./PatrimoineList.vue?vue&type=script&lang=js"

import "./PatrimoineList.vue?vue&type=style&index=0&id=53de8bcf&lang=scss&scoped=true"
import "../assets/css/campaignList.css?vue&type=style&index=1&id=53de8bcf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53de8bcf"]])

export default __exports__